import(/* webpackMode: "eager" */ "/vercel/path0/app/portefeuille/page.tsx");
